import { useLoginStore } from '../stores/login.js';
import { request } from './api.js';

// 刷新token
export const refreshToken = (data) => request('/_hotel/app/refreshToken', 'post', data);
// 登录
export const login = (data) => request('/_hotel/login', 'post', data);
// 手机号登录
export const phoneLogin = (data) => request('/_hotel/phone-login', 'post', data);
// 验证码登录
export const smsLogin = (data) => request('/_hotel/sms-login', 'post', data);
// 获取验证码
export const sendVerifyCode = (data) => request('/_hotel/sms/send-verify-code', 'post', data);
// 获取当前账号的门店列表
export const getBrandShopList = (data) => request('/_hotel/getBrandShopList', 'get', data, {}, true);
//消息
export const getNoticeList = (data) => request('/_hotel/notice', 'get', data);
//公告列表
export const getAnnouncementList = (data) => request('/_hotel/announcement', 'get', data);
//公告详情 + 标记已读
export const getAnnouncementDetail = (data) => request('/_hotel/announcement/detail', 'get', data);
// 礼物列表
export const getGiftList = (data) => request('/_hotel/gift', 'get', data);
// 餐食列表
export const getFoodList = (data) => request('/_hotel/shop_wares', 'get', data);
// 教练分组列表
export const getCoachGroupList = (data) => request('/_hotel/coach_type/coach_list', 'get', data);
// 商品列表
export const getShopWaresList = (data) => request('/_hotel/shop_wares', 'get', data);

// 购物车下单
export const preOrder = (data) => request('/_hotel/cart/order', 'post', data, {}, true);
// 桌台列表
export const getRoomList = (data) => request('/_hotel/room', 'get', data, {}, data?.loadingBoo);

// 教练分页列表
export const getCoachPageList = (data) => request('/_hotel/coach', 'get', data);

// 桌台账单详情
export const getRoomExpendDetail = (data) => request(`/_hotel/room_expend/preview/${data.id}`, 'get', data, {}, true);

//并桌
export const mergeRoom = (data) => request(`/_hotel/room/merge/${data.id}`, 'post', data);

// 换桌
export const changeRoom = (data) => request(`/_hotel/room/change/${data.id}`, 'post', data);

//暂停计费
export const pauseBilling = (data) => request(`/_hotel/room_expend/billing/pause/${data.id}`, 'PATCH', data);

// 恢复计费
export const resumeBilling = (data) => request(`/_hotel/room_expend/billing/resume/${data.id}`, 'PATCH', data);

// 计费规则列表
export const getBillingRulesList = (data) => request('/_hotel/billing_rules', 'get', data);

//开台
export const openRoom = (data) => request('/_hotel/room/order', 'post', data, {}, true);

//礼物账单
export const getGiftOrder = (data) => request(`/_hotel/gift_order`, 'get', data);

//消息已读  传id为单个  传type为整个类型
export const readNotice = (data) => request('/_hotel/notice/read', 'get', data);

// 全部已读
export const readAll = (data) => request('/_hotel/notice/read_all', 'get', data);

//分类列表  商品和餐食
export const getCategoryList = (data) => request('/_hotel/shop_wares/tags', 'get', data);

//教练的分类
export const getCoachTypeList = (data) => request('/_hotel/coach_type', 'get', data);

// 设置桌台状态
export const setRoomStatus = (data) => request('/_hotel/room/state', 'PATCH', data);

//置脏
export const setDirty = (data) => request('/_hotel/room/dirty', 'PATCH', data);
//置净
export const setClean = (data) => request('/_hotel/room/clean', 'PATCH', data);

//取消预定
export const cancelReserve = (data) => request('/_hotel/room/order/cancel_reserve', 'post', data);

//取消账单
export const cancelOrderBill = (data) => request(`/_hotel/room/order/${data.id}`, 'DELETE', data);

// 预定
export const reserveRoom = (data) => request('/_hotel/room/order/reserve', 'post', data);
// 修改预定
export const modifyReserve = (data) => request(`/_hotel/room/order/reserve/${data.id}`, 'put', data);

//账单
export const getBillList = (data) => request('/_hotel/data/bills', 'get', data);

//会员列表
export const getMemberList = (data) => request('/_hotel/member/list', 'get', data);

//获取店铺配置
export const getShopConfigApi = () => {
    const loginstore = useLoginStore();
    return request(`/_hotel/shop/${loginstore.currentShopId}`, 'get');
};
// 获取用户设置
export const getUserConfigApi = () => request('/_hotel/userinfo');
//添加打印机

export const addPrinter = (data) => request('/_hotel/printer', 'post', data);
//获取不分页打印机列表
export const getPrintList = (data) => request('/_hotel/printer/option', 'get', data);
// 获取分页的打印机列表
export const getPrintPageList = (data) => request('/_hotel/printers', 'get', data);
// 获取打印模板列表
export const getPrintTemplateList = (data) => request('/_hotel/printer/templates', 'get', data);
// 删除打印机
export const delPrinter = (data) => request(`/_hotel/printer/${data}`, 'delete');
//更新打印机
export const updatePrinter = (data) => request(`/_hotel/printer/${data.id}`, 'put', data);
// 云打印
export const printClound = (data) => request(`/_hotel/data/bill/print/${data.id}`, 'post', data);

//新增会员
export const addMemberApi = (data) => request('/_hotel/member/enter', 'post', data);

//会员列表
export const memberListApi = (data) => request('/_hotel/member/list', 'get', data);
// 会员本金变化记录
export const capitalRecord = (data) => request('/_hotel/member/balance-log', 'get', data);
// 会员赠金变化记录
export const bonusRecord = (data) => request('/_hotel/member/bonus-log', 'get', data);
// 会员积分变化记录
export const scoreRecord = (data) => request('/_hotel/member/score-log', 'get', data);
// 获取会员枚举
export const getmemberEnum = (data) => request('/_hotel/member/list/options', 'get', data);
// 会员可参加活动列表
export const getmemberActive = (data) => request('/_hotel/member/activities/all-valid-list', 'get', data);

// 桌台绑定会员
export const tableBindMember = (data) => request('/_hotel/room/order/member', 'PATCH', data);

// 桌台解绑会员
export const tableUnBindMember = (data) => request('/_hotel/room/order/member', 'delete', data);
// 查询单个会员信息
export const getMemberInfo = (id) => request(`/_hotel/member/${id}`, 'get');
//修改会员密码之发送短信
export const changeMemberPasswordForSms = (id) => request(`/_hotel/member/send-sms/${id}`, 'get');
//修改会员密码
export const changeMemberPassword = (data) => request(`/_hotel/member/password/${data.muser_id}`, 'put', data);
// 桌台下单
export const orderByDesk = (data) => request('/_hotel/cart/order', 'post', data, {}, true);
// 桌台挂单
export const paddingOrderByDesk = (data) => request('/_hotel/room/order/pending', 'post', data);
// 挂单备注列表
export const paddingRemarkList = () => request('/_hotel/room/order/pendingOrderRemarks', 'get');
// 删除挂单备注
export const deleteRemark = (id) => request(`/_hotel/room/order/delPendingOrderRemark/${id}`, 'delete');
// 挂单列表
export const paddingOrderList = (data) => request('/_hotel/room/order/pendingOrderList', 'get', data);

// 合并挂单
export const mergePenddingOrder = (data) => request('/_hotel/room/order/mergePendingOrder', 'post', data);
// 拆单至挂单或桌台
export const apartOrder = (data) => request('/_hotel/room/order/apart', 'post', data);
// 现金支付
export const advancePayment = (data) => request('/_hotel/room/order/advance_payment', 'post', data);
// 获取最新版本
export const getNewVersion = (data) => request('/app_version/latest_version', 'post', data);

//整单优惠
export const discountOrder = (data) => request(`/_hotel/room/order/discount-config/${data.id}`, 'put', data);

//二维码收款
export const qrcodePayment = (data) => request('/_hotel/room_expend/payment_online/qrcode', 'post', data);

//扫码收款结果
export const scanPaymentResult = (data) => request('/_hotel/room_expend/payment_online', 'post', data);

// 扫码收款状态
export const scanPaymentState = (data) => request('/_hotel/room_expend/payment_online/state', 'get', data);

// 找零
export const windup = (data) => request('/_hotel/room_expend/windup', 'post', data, {}, true);

// 退款
export const refund = (data) => request('/_hotel/room/order/advance_payment/refund', 'post', data);

//支付预览订单
export const previewPayment = (data) => request('/_hotel/room/order/advance_payment/preview', 'post', data);

// 暂停桌台所有计费项
export const pauseAllfee = (data) => request(`/_hotel/room_expend/billing/pauseAll/${data.bill_id}`, 'put', data);

// 恢复桌台所以计费项
export const resumeAllfee = (data) => request(`/_hotel/room_expend/billing/resumeAll/${data.bill_id}`, 'put', data);

//获取账单列表
export const getOrderListApi = (data) => request('/_hotel/orders', 'get', data);

//教练暂停
export const pauseCoach = (data) => request(`/_hotel/room_expend/coach/pause/${data.coach_id}`, 'PATCH');

//教练结束/_hotel/room_expend/coach/end
// {"room_order_id":2399,"expend_id":12069,"shop_id":6}
export const endCoach = (data) => request(`/_hotel/room_expend/coach/end`, 'PATCH', data);

//教练取消 /_hotel/room_expend/coach?room_order_id=2399&expend_id=12069&shop_id=6
export const cancelCoach = (data) => request(`/_hotel/room_expend/coach`, 'DELETE', data);

//教练恢复上课
export const resumeCoach = (data) => request(`/_hotel/room_expend/coach/resume/${data.coach_id}`, 'PATCH', data);

//教练修改时长
export const updateCoachTime = (data) => request(`/_hotel/room_expend/coach/setTime`, 'post', data);
//教练取消定时
export const cancelCoachTime = (data) => request(`/_hotel/room_expend/coach/cancelTime`, 'post', data);

//教练开始上课
export const startCoach = (data) => request(`/_hotel/room_expend/coach/start`, 'PATCH', data);
//教练设置定时
export const setCoachTime = (data) => request(`/_hotel/room_expend/coach/setTime`, 'post', data);

// 礼物数量更改
export const updateGiftCount = (data) => request(`/_hotel/room_expend/gift/count`, 'post', data);

// 充电取消订单
export const cancelCharge = (data) => request(`/_hotel/room_expend/charge/cancel`, 'post', data);

//商品订单改数量
export const updateShopCount = (data) => request(`/_hotel/room_expend/update-quantity`, 'put', data);

//商品送达
export const updateShopDelivery = (data) => request(`/_hotel/room_expend/deliver/${data.id}`, 'get', data);

//商品是否赠送
export const updateShopGive = (data) => request(`/_hotel/room_expend/shop/give`, 'post', data);

//桌台更改费率
export const updateRoomsRules = (data) => request(`/_hotel/room/order/billing-rule/${data.id}`, 'put', data);

//获取账单详情
export const getOrderDetailApi = (data) => request(`/_hotel/data/bill/${data}`, 'get');

//获取规格
export const getSpecUnitApi = (data) => request(`/_hotel/shop_goods_units`, 'get', data);

//获取日志列表
export const getLogList = (data) => request(`/_hotel/room/order/get-logs/${data.id}`, 'get', data);

// 获取消费场景列表
export const getSceneList = (data) => request('/_hotel/member/levels/options', 'get', data);
// 获取员工列表
export const getStaffListApi = (data) => request('/_hotel/hotel-staff?is_all=1', 'get', data);
// 获取挂单会员列表
export const getGuaMemberListApi = (data) => request('/_hotel/room/order/getPendingOrderMembers', 'post', data);

//消费下单
export const placeAnOrder = (data) => request(`/_hotel/retail/order`, 'post', data, {}, true);
//获取零售下单信息
export const getRetailOrder = (data) => request(`/_hotel/getRetailOrder`, 'get', data);
//收银机绑定
export const posBinding = (data) => request(`/_hotel/posBinding`, 'post', data);
// 根据金额反查可参加的活动
export const getActivityByAmount = (data) => request('/_hotel/member/charge/default-activity-and-plan', 'get', data);
//会员现金充值
export const chargeMember_cash = (data) => request('/_hotel/member/charge/combine/cash', 'post', data);
// 会员充值创建预账单
export const createPreChargeBill = (data) => request('/_hotel/member/charge/combine/order', 'post', data);

//充值支付预览订单
export const previewChargePayment = (data) => request('/_hotel/member/charge/combine/order', 'get', data);
//部分充值生成二维码
export const createChargeQrcode = (data) => request('/_hotel/member/charge/combine/qrcode', 'post', data);
// 会员充值支付结果
export const chargePaymentResult = (data) => request('/_hotel/member/charge/combine/sub/state', 'get', data);
// 会员充值支付码
export const createChargeAuth = (data) => request('/_hotel/member/charge/combine/scanqr', 'post', data);
// 取消会员预充值
export const cancelPreCharge = (data) => request('/_hotel/member/charge/combine/order', 'delete', data);

// 台费定时
export const setTimeBillingApi = (data) => request(`/_hotel/room/order/set-timer-billing/${data.id}`, 'put', data);

// 台费取消定时
export const cancelTimeBillingApi = (data) => request(`/_hotel/room/order/cancel-timer-billing/${data.id}`, 'put', data);

// 子账单取消台费
export const cancelSubBillingApi = (data) => request(`/_hotel/room/order/cancel-sub-billing/${data.id}`, 'put', data);
// 教练换桌
export const coachChangeRoomApi = (data) => request(`/_hotel/room_expend/coach/switch-table`, 'post', data);
// 会员分批充值等待告知服务端
export const waitChargeResult = (id) => request(`/_hotel/member/charge/combine/ping/${id}`, 'get');
// 台费改时长
export const changeRoomTimeApi = (data) => request(`/_hotel/room/order/change-duration/${data.id}`, 'put', data);
// 教练改时长
export const changeCoachTimeApi = (data) => request(`/_hotel/room_expend/coach/change-duration/${data.id}`, 'put', data);
// 教练定时
export const setCoachTimerApi = (data) => request(`/_hotel/room_expend/coach/set-timer-billing/${data.id}`, 'put', data);
// 教练取消定时
export const cancelCoachTimerApi = (data) => request(`/_hotel/room_expend/coach/cancel-timer-billing/${data.id}`, 'put', data);
// 同意开台
export const agreeOpenRoomApi = (data) => request(`/_hotel/room/order/preview`, 'post', data);
// 拒绝开台
export const refuseOpenRoomApi = (data) => request(`/_hotel/room/refuse_order`, 'get', data);
// 教练按次的修改数量
export const updateCoachCountApi = (data) => request(`/_hotel/room_expend/coach/update-quantity`, 'put', data);
// 结束充电
export const endChargeApi = (data) => request(`/_hotel/room_expend/charge/complete`, 'post', data);
// 更改教练礼物数量
export const updateCoachGiftCountApi = (data) => request(`/_hotel/gift_order/num/${data.id}`, 'put', data);
// 账单备注修改
export const updateBillRemarkApi = (data) => request(`/_hotel/room/order/remark/${data.id}`, 'put', data);
// 教练换人
export const changeCoachApi = (data) => request(`/_hotel/room_expend/coach/switch-coach`, 'post', data);
// 取消商品订单
export const cancelGoodsApi = (data) => request(`/_hotel/room_expend`, 'delete', data);
// 取消礼物订单
export const cancelGiftApi = (data) => request(`/_hotel/gift_order/cancel/${data.id}`, 'put', data);
//充值账单详情
export const getChargeOrderDetailApi = (data) => request(`/_hotel/member/charge/${data.id}`, 'get', data);
// 赠送商品
export const giveGoodsApi = (data) => request(`/_hotel/room_expend/convert-to-gift`, 'put', data);
// 取消赠送商品
export const cancelGiveGoodsApi = (data) => request(`/_hotel/room_expend/give_back`, 'get', data);
// 打印充值账单小票
export const printChargeOrderApi = (data) => request(`/_hotel/member/charge/print/${data.id}`, 'post', data);
// 设置默认打印机
export const setDefaultPrinterApi = (data) => request(`/_hotel/printer/default`, 'patch', data);

//根据扫码出来的内容，获取团购信息
export const getGroupByCode = (data) => request(`/_hotel/third-group-buying/get-code-from-short-url`, 'post', data);

//团购核销
export const prepareGroupBuyApi = (data) => request(`/_hotel/room/order/prepare/${data.id}`, 'get', data);

//活动套餐列表
export const getActivityListApi = (data) => request(`/_hotel/package-activities`, 'get', data);

//获取套餐详情
export const getActivityDetailApi = (data) => request(`/_hotel/package-activities/${data.id}`, 'get', data);

//添加团购套餐 /_hotel/room/order/add-group-buy/{id}
export const addGroupBuyApi = (data) => request(`/_hotel/room/order/add-group-buy/${data.id}`, 'post', data, {}, true);

//修改门店配置信息
export const setShopConfigApi = (data) => {
    const loginstore = useLoginStore();
    return request(`/_hotel/shop/config`, 'put', { ...data, shop_id: loginstore.currentShopId });
};

//设置整单优惠
export const setBillDiscount = (data) => request(`/_hotel/room_expend/setBillDiscount`, 'post', data);

// 查询账单中需要补充的套餐详情 /_hotel/room/order/get-activity-by-bill/{id}
export const getActivityByBillApi = (data) => request(`/_hotel/room/order/get-activity-by-bill/${data.id}`, 'get', data);

//补充套餐  _hotel/room/order/supplement-package/{id}
export const updateActivityApi = (data) => request(`/_hotel/room/order/supplement-package/${data.id}`, 'post', data, {}, true);

// 桌台的统计 /_hotel/room/statistics
export const getRoomCountStatisticsApi = (data) => request(`/_hotel/room/statistics`, 'get', data);
// 教练的统计 /_hotel/coach/statistics
export const getCoachCountStatisticsApi = (data) => request(`/_hotel/coach_type/statistics`, 'get', data);

//账单的筛选前置分类
export const getOrderKeywordsApi = (data) => request(`/_hotel/orders/get-order-keywords`, 'get', data);
